import { COLORS } from "../constants/colors/colors";
import { CONTRAST_ENUM } from "../pages/SettingsPage/constants/constants";

export interface GlassmorphismStyles {
  background: string;
  backdropFilter: string;
  webkitBackdropFilter: string;
  border: string;
  color: string;
}

export const getContrastTextColor = (
  contrast: CONTRAST_ENUM = CONTRAST_ENUM.STANDARD,
): string => {
  switch (contrast) {
    case CONTRAST_ENUM.DARK:
    case CONTRAST_ENUM.STANDARD:
      return COLORS.WHITE;
    case CONTRAST_ENUM.WHITE:
    default:
      return COLORS.BOUNDLESS_BLUE;
  }
};

export const getContrastBackgroundColor = (
  contrast: CONTRAST_ENUM = CONTRAST_ENUM.STANDARD,
): string => {
  switch (contrast) {
    case CONTRAST_ENUM.DARK:
      return COLORS.BOUNDLESS_BLUE;
    case CONTRAST_ENUM.WHITE:
      return COLORS.GRAY_LIGHT;
    case CONTRAST_ENUM.STANDARD:
    default:
      return "rgba(34, 64, 77, 0.25)";
  }
};

export const getProgressTrackColor = (
  contrast: CONTRAST_ENUM = CONTRAST_ENUM.STANDARD,
): string => {
  switch (contrast) {
    case CONTRAST_ENUM.WHITE:
      return COLORS.GRAY;
    case CONTRAST_ENUM.DARK:
      return "rgba(0, 0, 0, 0.2)";
    case CONTRAST_ENUM.STANDARD:
    default:
      return "rgba(34, 64, 77, 0.25)";
  }
};

export const getGlassmorphismStyles = (
  contrast: CONTRAST_ENUM = CONTRAST_ENUM.STANDARD,
): GlassmorphismStyles => {
  switch (contrast) {
    case CONTRAST_ENUM.STANDARD:
      return {
        background: "rgba(34, 64, 77, 0.25)",
        backdropFilter: "blur(9px)",
        webkitBackdropFilter: "blur(9px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        color: COLORS.WHITE,
      };
    case CONTRAST_ENUM.WHITE:
      return {
        background: COLORS.GRAY_LIGHT,
        backdropFilter: "none",
        webkitBackdropFilter: "none",
        border: "none",
        color: COLORS.IMMERSIVE_BLUE_DARK,
      };
    case CONTRAST_ENUM.DARK:
      return {
        background: COLORS.BOUNDLESS_BLUE,
        backdropFilter: "none",
        webkitBackdropFilter: "none",
        border: "none",
        color: COLORS.WHITE,
      };
    default:
      return {
        background: "rgba(34, 64, 77, 0.25)",
        backdropFilter: "blur(6px)",
        webkitBackdropFilter: "blur(6px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        color: COLORS.WHITE,
      };
  }
};
